import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 498,
    },
    dialogTitle: {
      borderBottom: 'unset',
    },
    dialogContent: {
      padding: theme.spacing(2, 4, 3),
    },
    body: {
      borderRadius: theme.shape.borderRadius,
      border: theme.shape.borderGray70,
      overflow: 'hidden',
    },
    scrollable: {
      padding: 0,
    },
    brandVoiceRow: {
      width: '100%',
      padding: theme.spacing(2),
      '& + &': {
        borderTop: theme.shape.borderGray70,
      },
      '&:hover': {
        backgroundColor: COLORS.gray.gray90,
      },
    },
    label: {
      display: 'flex',
      justifyContent: 'space-between',
      color: COLORS.gray.black,
      width: '100%',
    },
    checkbox: {
      padding: theme.spacing(0),

      '& svg': {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    brandVoiceRulesLength: {
      ...theme.typography.regular14,
      '&:hover': {
        textDecoration: 'underline',
      },
    },

    buttonCancel: {},
    buttonSubmit: {
      minWidth: 'unset',
    },
  }),
  { name: 'BrandRuleSetsPopup' }
);
